import React, { useState, useEffect } from "react";
import { Card, CardBody, Col, Container, Row, Button, Spinner } from "reactstrap";
import DataTable from "react-data-table-component";
import {
  Add,
  ViewPackagePaymentSettingTitle,
  PackagePaymentSettingTitle,
} from "../../../Utils/Constants";
import Breadcrumbs from "../../../CommonElements/Breadcrumbs";
import axios from "axios";
import useCurrency, { baseUrl, mediaUrl } from "../../../Utils/FileUpload";
import { PackagePaymentSetting } from "../../../Types/Tables.type";
import FilterComponent from "../../../Components/Tables/DataTables/Common/FilterComponent";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Btn, H3, P } from "../../../AbstractElements";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../Context/AuthContext";

export default function ViewPackagePaymentSetting() {
  const [filterText, setFilterText] = useState("");
  const [filteredItems, setFilteredItems] = useState<PackagePaymentSetting[]>([]);
  const [refresh, setRefresh] = useState(0);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [disabledDelete, setDisabledDelete] = useState<string | null>(null);
  const [disableAllDelete, setDisableAllDelete] = useState(false);
  const token = localStorage.getItem("token");
  const { currency } = useCurrency();
  const { hasPermission } = useAuth();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${baseUrl}package_payment_setting/getall`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const data: PackagePaymentSetting[] = response.data;
        // setFilteredItems(
        //   data
        //     .filter((brand) => brand.is_deleted === 0)
        //     .sort((a, b) => b.is_active - a.is_active) // 👈 actived ones first
        // );
        setFilteredItems(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [refresh]);

  const handleAdd = () => {
    navigate("/add_package_payment_setting");
  };
  const filteredData = filteredItems.filter((item: PackagePaymentSetting) => {
    const search = filterText.toLowerCase();
    return (
      item.base_amount.toString().toLowerCase().includes(search) ||
      item.base_customer_credit_point.toString().toLowerCase().includes(search) ||
      item.base_call_duration.toString().toLowerCase().includes(search) ||
      item.base_agent_point.toString().toLowerCase().includes(search) ||
      item.base_agent_payment.toString().toLowerCase().includes(search)
    );
  });

  const handleEdit = (id: string) => {
    navigate("/edit_package_payment_setting", { state: { id: id } });
  };


  const packagePaymentSettingTableColumns = [
    {
      name: <div>Recharge Amount ({currency || "₹"})</div>,
      selector: (row: PackagePaymentSetting) => row.base_amount,
      sortable: true,
      width: "19%",
    },
    {
      name: <div>Customer Points</div>,
      selector: (row: PackagePaymentSetting) => row.base_customer_credit_point,
      sortable: true,
      width: "16%",
    },
    {
      name: <div>Call Duration (mins)</div>,
      selector: (row: PackagePaymentSetting) => row.base_call_duration,
      sortable: true,
      width: "18%",
    },
    {
      name: <div>Agent Points</div>,
      selector: (row: PackagePaymentSetting) => row.base_agent_point,
      sortable: true,
      width: "15%",
    },
    {
      name: <div>Agent Payment ({currency || "₹"})</div>,
      selector: (row: PackagePaymentSetting) => row.base_agent_payment,
      sortable: true,
      width: "20%",
    },
    {
      name: "Actions",
      cell: (row: PackagePaymentSetting) => (
        <div className="d-flex justify-content-between">
          {hasPermission("audio-package-setting.edit") && (
            <Button
              color="primary"
              size="sm"
              onClick={() => handleEdit(row.id)}
              style={{
                marginRight: "5px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              title="Edit"
            >
              <i className="icon-pencil-alt" />
            </Button>
          )}
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      // button: true,
      width: "12%",
    },
  ];

  // Show a loading spinner while data is being fetched
  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spinner color="primary" />
      </div>
    );
  }
  const customStyles = {
    headCells: {
      style: {
        fontSize: "16px",
        fontWeight: "600",
        color: "#308e87",
        backgroundColor: "#f8f9fa",
        borderBottom: "2px solid #308e87",
      },
    },
    rows: {
      style: {
        borderBottom: "1px solid #dee2e6",
      },
    },
    table: {
      style: {
        border: "1px solid #dee2e6",
        borderRadius: "8px",
      },
    },
  };
  if (!hasPermission("audio-package-setting.view")) {
    return (
      <div className="page-body">
        <Container fluid>
          <Row className="justify-content-center align-items-center" style={{ minHeight: "calc(100vh - 160px)" }}>
            <Col md={7} lg={5} className="text-center">
              <Card
                className="border-0 shadow-lg position-relative overflow-hidden"
                style={{
                  borderRadius: "24px",
                  boxShadow: "0 20px 50px -10px rgba(0, 0, 0, 0.08)",
                  background: "#ffffff",
                }}
              >
                <div
                  style={{
                    height: "5px",
                    width: "100%",
                    background: "linear-gradient(90deg, #308e87 0%, #00b4d8 100%)",
                  }}
                />
                <CardBody className="p-4 p-md-5">
                  <div
                    className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                    style={{
                      width: "84px",
                      height: "84px",
                      background: "linear-gradient(135deg, rgba(48, 142, 135, 0.1) 0%, rgba(0, 180, 216, 0.15) 100%)",
                      color: "#308e87",
                      border: "1px solid rgba(48, 142, 135, 0.2)",
                    }}
                  >
                    <i className="fa fa-info-circle fa-2x"></i>
                  </div>
                  <div>
                    <span
                      className="badge bg-light-info text-info mb-3 px-3 py-2 rounded-pill fw-bold"
                      style={{ fontSize: "0.75rem", letterSpacing: "0.8px", textTransform: "uppercase" }}
                    >
                      Configuration Active
                    </span>
                  </div>
                  <H3 className="fw-bold text-dark mb-2">Setting Configuration Already Exists</H3>
                  <P className="text-muted mb-0 px-lg-2" style={{ fontSize: "0.95rem", lineHeight: "1.6" }}>
                    {filteredItems.length > 0
                      ? "Only one Audio Package Setting configuration is permitted in the system and a record is already active. Creating an additional record is disabled."
                      : "You do not have administrative privileges to view Audio Package Settings."}
                  </P>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  return (
    <>
      <Breadcrumbs
        pageTitle={ViewPackagePaymentSettingTitle}
        parent={PackagePaymentSettingTitle}
        title={ViewPackagePaymentSettingTitle}
      />
      <Col xl={12} className="mb-lg-3">
        <Card>
          <CardBody>
            {/* If no record exists, allow adding a new one */}
            {filteredItems.length === 0 && hasPermission("audio-package-setting.add") && (
              <Col xs={12} className="mt-2 d-flex justify-content-end mb-3">
                <Btn color="primary" onClick={handleAdd}>
                  {Add}
                </Btn>
              </Col>
            )}

            {/* Informative notice when record already exists and user has ADD permission */}
            {filteredItems.length > 0 && hasPermission("audio-package-setting.add") && (
              <div className="alert alert-light-info d-flex align-items-center mb-3 p-3 border border-info rounded-3" style={{ fontSize: "13px" }}>
                <i className="fa fa-info-circle me-2 text-info fs-5"></i>
                <div>
                  <strong>Configuration Active:</strong> An Audio Package Setting record already exists. Only one configuration is permitted in the system, so creating an additional record is disabled.
                </div>
              </div>
            )}
            <div className="table-responsive">
              <DataTable
                data={filteredData}
                columns={packagePaymentSettingTableColumns}
                pagination
                highlightOnHover
                striped
                customStyles={customStyles}
              />
            </div>
          </CardBody>
        </Card>
      </Col>
      <ToastContainer />
    </>
  );
}
